import { Button } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import React from 'react';
import styles from './GetTheAppButton.module.css';

const cx = classnames.bind(styles);

export default function GetTheAppButton(props) {
  return (
    <Button
      as="a"
      className={cx('cta')}
      cta
      href="//routing.gasbuddy.com/app"
      fluid
      primary
      size="lg"
      {...props}
    >
      Download The App
    </Button>
  );
}
